import services from 'api/services';
import { logError } from 'util/errors';

import { LOAD_CMS_CHALLENGES_REQUEST, LOAD_CMS_CHALLENGES_SUCCESS, LOAD_CMS_CHALLENGES_FAILURE } from './constants';

const { TestService } = services;

export const getAllChallengesForCMS = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_CMS_CHALLENGES_REQUEST });
    const response = await TestService.getAllChallengesForCMS();
    dispatch({ type: LOAD_CMS_CHALLENGES_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_CMS_CHALLENGES_FAILURE, error: ex.message });
  }
};
